export default "__VITE_ASSET__B1rVH9b___"